export default "__VITE_ASSET__CeIHdh8x__"